module.exports = __webpack_public_path__ + "img/oppo_a73_100x100.9d1ad6c5.png";